
namespace TerminalApp {

    class SerialNumberModel {
        Id: string;
        itemInfo: SP.ItemInfo;
        ShipmentLineData: SP.ShipmentLineData;
    }

    export class SerialNumberAssistant extends Assistant {
        sn_menu = document.createElement("div");

        scansDoneText: HTMLElement;
        scansLeftText: HTMLElement;

        imageElement: HTMLImageElement;
        titleText: HTMLElement;
        inputElement: HTMLInputElement;
        errorElement: HTMLElement;

        nextBtn: HTMLElement;
        backBtn: HTMLElement;

        bound = false;
        runUpdateOnClose = true;

        scansDoneNumber: number = 0;

        shipmentId: string;
        serialNumberArray: SerialNumberModel[] = [];

        callback: () => void;

        constructor() {
            super();

            this.initialize();

            // Back btn click
            this.backBtn.addEventListener("click", () => {
                this.clickBackFunction();
            });

            // Next btn click
            this.nextBtn.addEventListener("click", () => {
                this.clickNextFunction();
            })

            this.inputElement.addEventListener("keydown", (e) => {
                if (e.key == "Enter") {
                    this.nextFunction();
                }
            });
        }

        hide() {
            this.sn_menu.style.display = "none";
        }

        sn_open() {
            this.hide();

            this.loadModalData();

            this.container.style.display = "block";
            this.sn_menu.style.display = "block";
        }

        async open(serialNumberArray: SerialNumberModel[], shipmentId: string, callback: () => void) {
            this.reset();

            if (!this.bound) {
                this.bound = true;
                barcodeListener.on(null, this.scanSerialNumber, this);
            }

            this.callback = callback;

            this.shipmentId = shipmentId;
            this.serialNumberArray = serialNumberArray;

            this.sn_open();
        }

        async close() {
            if (this.bound) {
                this.bound = false;
                barcodeListener.off(null, this.scanSerialNumber);
            }

            if (!this.validateAndAdd(false)) {
                return;
            }

            if (this.runUpdateOnClose) {
                await this.updateShipmentDataLine(false);
            }

            this.callback();

            this.reset();
            this.clear();
            super.close();
        }

        reset() {
            this.titleText.innerText = "";
            this.imageElement.src = "/images/noimage/noimage.jpg";
            this.inputElement.value = "";
            this.inputElement.classList.remove("serialNumber-input-error");

            this.errorElement.innerText = "";
        }

        clear() {
            this.runUpdateOnClose = true;
            this.scansDoneNumber = 0;
            this.shipmentId = null;
            this.serialNumberArray = [];
        }

        scanSerialNumber(serialNumber:string) {
            this.inputElement.value = serialNumber;
        }

        clickNextFunction() {
            this.nextFunction();
        }

        clickBackFunction() {

            if (this.scansDoneNumber != 0) {

                if (!this.validateAndAdd(true)) {
                    return;
                }

                this.scansDoneNumber -= 1;

                this.loadModalData();
                return;
            }
        }

        loadModalData() {
            this.reset();

            this.scansDoneText.innerText = (this.scansDoneNumber + 1).toString();
            this.scansLeftText.innerText = this.serialNumberArray.length.toString();
            this.titleText.innerText = this.serialNumberArray[this.scansDoneNumber].itemInfo.description;
            this.imageElement.src = this.serialNumberArray[this.scansDoneNumber].itemInfo.imageUrl;
            this.inputElement.value = this.serialNumberArray[this.scansDoneNumber].ShipmentLineData?.value ?? "";
        }

        nextFunction() {
            if (this.scansDoneNumber != this.serialNumberArray.length) {

                if (!this.validateAndAdd(false)) {
                    return;
                }

                if (this.scansDoneNumber === this.serialNumberArray.length - 1) {
                    this.runUpdateOnClose = false;
                    this.updateShipmentDataLine(true);
                }

                if (this.scansDoneNumber != this.serialNumberArray.length - 1) {
                    this.scansDoneNumber += 1;
                }

                this.loadModalData();
                return;
            }
        }

        validateAndAdd(allowEmptyInput:boolean) {
            if (!allowEmptyInput && this.inputElement.value.length == 0) {
                this.inputElement.classList.add("serialNumber-input-error");
                this.errorElement.innerText = SP.Localize("sentance_you_must_fill_in_the_field");
                return false;
            }
            else if (this.validateSerialNumber()) {
                this.inputElement.classList.add("serialNumber-input-error");
                this.errorElement.innerText = SP.Localize("sentance_serial_number_already_in_use");

                return false;
            }

            if (this.serialNumberArray[this.scansDoneNumber].ShipmentLineData == null) {
                this.serialNumberArray[this.scansDoneNumber].ShipmentLineData = {
                    id: SP.Guid.Empty,
                    type: SP.ShipmentLineDataType.SerialNumber,
                    value: this.inputElement.value.trim()
                }
            }
            else if (this.serialNumberArray[this.scansDoneNumber].ShipmentLineData.value != this.inputElement.value) {
                this.serialNumberArray[this.scansDoneNumber].ShipmentLineData = {
                    id: this.serialNumberArray[this.scansDoneNumber].ShipmentLineData.id,
                    type: SP.ShipmentLineDataType.SerialNumber,
                    value: this.inputElement.value.trim()
                }
            }

            return true;
        }

        // Check if the serialnumber already exist in the array
        validateSerialNumber() {
            let inputValue = this.inputElement.value.trim();

            for (var i = 0; i < this.serialNumberArray.length; i++) {

                let isNull = false;
                if (this.serialNumberArray[i].ShipmentLineData == null) {
                    isNull = true;
                }

                if (!isNull && i == this.scansDoneNumber && this.serialNumberArray[i].ShipmentLineData.value === this.serialNumberArray[this.scansDoneNumber].ShipmentLineData.value) {
                    continue;
                }

                if (!isNull && this.serialNumberArray[i].Id === this.serialNumberArray[this.scansDoneNumber].Id && this.serialNumberArray[i].ShipmentLineData.value === inputValue) {
                    return true;
                }
            }

            return false;
        }

        async updateShipmentDataLine(close:boolean) {

            let postArray = [];

            for (var i = 0; i < this.serialNumberArray.length; i++) {

                if (this.serialNumberArray[i].ShipmentLineData != null) {
                    let thisId = null;

                    if (this.serialNumberArray[i].ShipmentLineData.id != null) {
                        thisId = this.serialNumberArray[i].ShipmentLineData.id;
                    }

                    var postData = {
                        Id: thisId,
                        ShipmentLineId: this.serialNumberArray[i].Id,
                        Type: SP.ShipmentLineDataType.SerialNumber,
                        Value: this.serialNumberArray[i].ShipmentLineData.value
                    }

                    postArray.push(postData);
                }
            }

            let result = await SP.post<any>("/api/v1/shipment/updateshipmentlinedata/", postArray);

            if (result.status == 200) {
                if (close) {
                    this.close();
                }
            }
            else {
                console.log(result.status);
                console.log("Error");
                await SP.alertX("Error");
            }

        }

        initialize() {

            this.sn_menu.innerHTML = `
                <div class="setting_group setting_group-custom" style="position: relative;">

                    <p class="serialNumber-scans"><span class="serialNumber-scansDone">1</span>/<span class="serialNumber-scansLeft">4</span></p>

                    <div class="serialNumber-container">
                        <div class="serialNumber-image-container">
                            <img class="serialNumber-image" src = "" />
                        </div>

                        <p class="serialNumber-name-text"></p>

                        <div class="serialNumber-border"></div>

                        <div class="serialNumber-input-container">
                            <p class="serialNumber-input-headline">${SP.Localize("sentence_scan_or_type_serial_number")}</p>
                            <input class="serialNumber-input" type="text" placeholder="000000" />
                            <span class="serialNumber-error"></span>
                        </div>

                        <div class="serialNumber-border"></div>

                        <div class="serialNumber-btns-container">
                            <a class="serialNumber-btn serialNumber-btns-back">${SP.Localize("word_back")}</a>
                            <a class="serialNumber-btn serialNumber-btns-done">${SP.Localize("word_next")}</a>
                        </div>
                    <div>
                </div>
            `;

            this.scansDoneText = this.sn_menu.querySelector(".serialNumber-scansDone");
            this.scansLeftText = this.sn_menu.querySelector(".serialNumber-scansLeft");

            this.imageElement = this.sn_menu.querySelector(".serialNumber-image");
            this.titleText = this.sn_menu.querySelector(".serialNumber-name-text");
            this.inputElement = this.sn_menu.querySelector(".serialNumber-input");
            this.errorElement = this.sn_menu.querySelector(".serialNumber-error");

            this.backBtn = this.sn_menu.querySelector(".serialNumber-btns-back");
            this.nextBtn = this.sn_menu.querySelector(".serialNumber-btns-done");

            this.container.appendChild(this.sn_menu);
        }

    }
}